// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCalendarIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M22 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10h20zM16 2a1 1 0 0 1 1 1v1h3a2 2 0 0 1 2 2v2H2V6a2 2 0 0 1 2-2h3V3a1 1 0 0 1 2 0v1h6V3a1 1 0 0 1 1-1" />
  </g>
);
export default SvgCalendarIcon;
SvgCalendarIcon.displayName = 'SvgCalendarIcon';
